<template>
<v-flex :class="classes" >
<v-autocomplete
      v-model="fieldValue"
      :label="label"
      :required="required"
      :items="items"
      :loading="loading"
      :filter="customFilter"
      :item-text="from"
      item-value="id"
      :error-messages="errorMessages"
      browser-autocomplete="off"
    />
</v-flex>
</template>

<script>
import FieldMixin from '@/components/form/FieldMixin'
import { getValue } from '@/utils'

export default {
  mixins: [FieldMixin],
  computed: {
    watched () {
      return getValue(this.form.data, this.cascade ? this.cascade.target : 'unmatched_path')
    },
    items () {
      let results = this.$store.getters[`${this.source}/unfiltered`]
      if (this.watched !== undefined) {
        return results.filter(item => (parseInt(item[this.cascade.value]) === this.watched))
      }
      return results
    },
  },
}
</script>
